/* eslint-disable @typescript-eslint/no-explicit-any */
import { flattenComplexObject } from 'utils/format/object'
import { EventSenderPlugin } from '.'
import { Metadata } from '../types'

declare global {
  interface Window {
    clarity: (action: string, key: string, value: any) => void
  }
}

export class ClarityPlugin extends EventSenderPlugin {
  constructor() {
    super('Clarity')
  }

  updateUserMetadata(metadata: Metadata): void {
    if (window.clarity) {
      const metadataPlain = flattenComplexObject(metadata)

      Object.entries(metadataPlain).forEach(([key, value]) => {
        window.clarity('set', key, value)
      })
    }
  }
}
